/* eslint-disable */
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";
import PropTypes from "prop-types";

export default function UniversalLineChartComponent({
  data,
  lines,
  xAxisKey = "name",
  height = 300,
  referenceLinesColor = "var(--borderGray)",
  referenceLinesStep = 100,
  showReferenceLines = true,
  
}) {
  const chartData = data || [];

  // Use the first line's dataKey for Y-axis range calculation
  const yAxisKey = lines?.[0]?.dataKey;

  function getYAxisScale(data, key, step = 100) {
    console.log(data);
    
    const values = data.map((item) => item[key] ?? 0); // Handle undefined values
    const min = Math.min(...values);
    const max = Math.max(...values);
    const roundedMin = Math.floor(min / step) * step;
    const roundedMax = Math.ceil(max / step) * step;

    const ticks = [];
    for (let i = roundedMin; i <= roundedMax; i += step) {
      ticks.push(i);
    }

    return {
      domain: [roundedMin, roundedMax],
      ticks,
    };
  }

  const { domain, ticks } = getYAxisScale(
    chartData,
    yAxisKey,
    referenceLinesStep
  );

  return (
    <div className="w-full">
      <ResponsiveContainer width="100%" height={height}>
        <LineChart data={chartData}>
          <XAxis
            dataKey={xAxisKey}
            stroke="#555"
            style={{ fontFamily: "Poppins-Regular", fontSize: "13px" }}
            // axisLine={false}
          />
          <YAxis
            stroke="#555"
            domain={domain}
            ticks={ticks}
            style={{ fontFamily: "Poppins-Regular", fontSize: "14px" }}
            tickLine={false}
          />
          <Tooltip />
          {lines.map((line, index) => (
            <Line
              key={index}
              type={line.type || "linear"}
              dataKey={line.dataKey}
              stroke={line.stroke || "#7BD7CD"}
              strokeWidth={line.strokeWidth || 2}
              dot={line.dot ?? false}
              name={line.name || line.dataKey}
            />
          ))}
          {showReferenceLines &&
            ticks.map((value) => (
              <ReferenceLine
                key={value}
                y={value}
                stroke={referenceLinesColor}
              />
            ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

UniversalLineChartComponent.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  lines: PropTypes.arrayOf(
    PropTypes.shape({
      dataKey: PropTypes.string.isRequired,
      name: PropTypes.string,
      stroke: PropTypes.string,
      strokeWidth: PropTypes.number,
      dot: PropTypes.bool,
      type: PropTypes.oneOf(["linear", "monotone", "step", "basis", "natural"]),
    })
  ).isRequired,
  xAxisKey: PropTypes.string,
  height: PropTypes.number,
  referenceLinesColor: PropTypes.string,
  referenceLinesStep: PropTypes.number,
  showReferenceLines: PropTypes.bool,
};

//======================================>
//      how to use this component
// =====================================>

  //  <UniversalLineChartComponent
  //       data={[
  //     { date: "Aug 1", blueLine: 420, redLine: 290 },
  //     { date: "Aug 2", blueLine: 530, redLine: 310 },
  //     { date: "Aug 3", blueLine: 810, redLine: 600 }]}
  //      lines={[
  //         { dataKey: "blueLine", name: "Sales", stroke: "#8884d8" },
  //         { dataKey: "redLine", name: "Revenue", stroke: "#82ca9d" },
  //       ]}
  //       xAxisKey="date"
  //       referenceLinesValue={50}
  //     />
